"use client";

import { RetailerFooter } from "@faire/retailer-visitor-shared/components/Footer/RetailerFooter";
import { LazyLoggedOutMobileSignUpSnackbar } from "@faire/retailer-visitor-shared/components/LoggedOutMobileSignUpSnackbar/index";
import { BlockInheritRow } from "@faire/retailer-visitor-shared/components/SearchProducts/SearchProductsStyles";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { MaybeRenderSEMTextBlock } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageMaybeRenderSEMTextBlock/SearchPageMaybeRenderSEMTextBlock";
import { WhenVisibilityIsImminent } from "@faire/web--source/ui/VisibilitySensor/WhenVisibilityIsImminent";
import React, { Suspense } from "react";
import styled from "styled-components";

export const SearchOrDiscoverPageBelowFooter = () => {
  const isLoggedInRetailer = useIsLoggedInRetailer();
  return (
    <>
      <MaybeRenderSEMTextBlock />
      <SearchPageBelowFooter />
      {!isLoggedInRetailer ? (
        <Suspense fallback={null}>
          <LazyLoggedOutMobileSignUpSnackbar />
        </Suspense>
      ) : null}
    </>
  );
};

export const SearchPageBelowFooter = () => {
  return (
    <WhenVisibilityIsImminent customizePlaceholder={<FaireFooterPlaceholder />}>
      <FaireFooter />
    </WhenVisibilityIsImminent>
  );
};

const FaireFooterPlaceholder = styled.div`
  height: 400px;
  width: 100%;
`;

const FaireFooter = () => {
  return (
    <BlockInheritRow>
      <RetailerFooter hideReferral />
    </BlockInheritRow>
  );
};
